import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import BalancoService from '../../../../services/balanco';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [fundo, setFundo] = useState("");
    const [tipo, setTipo] = useState("");
    const [ano, setAno] = useState("");



    const busca = async (query) => {
        if (query == "") {
            props.setAindaTem(true)
            await props.fetchBalancosIn()
        } else {
            var response = await BalancoService.buscar(query)
            if (response.data.length >= 1) {
                props.setBalancos(response.data)
                props.setAindaTem(false)
                props.setVazio(false)
            } else {
                props.setVazio(true)
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (fundo !== "false" && fundo !== "") prepQuery = prepQuery + `&fundo=${encodeURI(fundo)}`;
        if (tipo !== "false" && tipo !== "") prepQuery = prepQuery + `&tipo=${encodeURI(tipo)}`;
        if (ano !== "false" && ano !== "") prepQuery = prepQuery + `&ano=${ano}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={1} lg={4}>
                            <Form.Group className="mb-3" controlId="fundo">
                                <FloatingLabel
                                    label="Fundo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="fundo"
                                        name="fundo"
                                        onChange={e => setFundo(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="Consolidado">Consolidado</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal de Habitação">Fundo Municipal de Habitação</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal de Educação">Fundo Municipal de Educação</option>
                                        <option value="Fundo Municipal dos Direitos da Criança e dos Adolescentes">Fundo Municipal dos Direitos da Criança e dos Adolescentes</option>
                                        <option value="Prefeitura Municipal">Prefeitura Municipal</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={1} lg={4}>
                            <Form.Group className="mb-3" controlId="tipo">
                                <FloatingLabel
                                    label="Tipo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="tipo"
                                        name="tipo"
                                        onChange={e => setTipo(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="Financeiro">Financeiro</option>
                                        <option value="Orçamentário">Orçamentário</option>
                                        <option value="Patrimonial">Patrimonial</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={1} lg={2}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/balanco'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <br /><br />
                    <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                        <Accordion.Body>
                            <Row xs={1}>
                                <Col xs={12}>
                                    <Exportar data={props.balancos} nome={"Balanços"} />
                                </Col>
                            </Row>
                            <br/>
                            <Row xs={1}>
                                <Col xs={12}>
                                    <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#d695fc79-ebad-4afd-af20-633737d3951b" target='_blank'>
                                        <Button>API e sua documentação</Button>
                                    </a>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca